import { render, staticRenderFns } from "./LegendLink.vue?vue&type=template&id=20ea2696"
import script from "./LegendLink.vue?vue&type=script&lang=js"
export * from "./LegendLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ea2696')) {
      api.createRecord('20ea2696', component.options)
    } else {
      api.reload('20ea2696', component.options)
    }
    module.hot.accept("./LegendLink.vue?vue&type=template&id=20ea2696", function () {
      api.rerender('20ea2696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/LegendLink.vue"
export default component.exports